(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jk-footer"]) return;
  try {
    
const DUREE = 320;
const COURBE = 'cubic-bezier(0.33, 0, 0.2, 1)';

class JkFooterAccordion extends HTMLElement {
  connectedCallback() {
    try {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.contenu = this.querySelector('details > nav');
      if (!this.details || !this.summary || !this.contenu) return;

      this.query = window.matchMedia('(min-width: 750px)');
      this.reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.sync = this.sync.bind(this);
      this.onClick = this.onClick.bind(this);

      this.query.addEventListener('change', this.sync);
      this.summary.addEventListener('click', this.onClick);
      this.sync();
    } catch (error) {
      this.querySelector('details')?.setAttribute('open', '');
    }
  }

  disconnectedCallback() {
    this.query?.removeEventListener('change', this.sync);
    this.summary?.removeEventListener('click', this.onClick);
  }

  reinitialise() {
    this.animation?.cancel();
    this.animation = null;
    this.contenu.style.height = '';
    this.contenu.style.overflow = '';
  }

  sync() {
    this.reinitialise();
    this.details.open = this.query.matches;
  }

  onClick(event) {
    if (this.query.matches) return;

    event.preventDefault();

    if (this.reduit.matches) {
      this.details.open = !this.details.open;
      return;
    }

    try {
      const ouvrait = this.details.open;
      this.reinitialise();
      this.details.open = true;

      const hauteur = this.contenu.scrollHeight;
      this.contenu.style.overflow = 'hidden';

      this.animation = this.contenu.animate(
        { height: ouvrait ? [`${hauteur}px`, '0px'] : ['0px', `${hauteur}px`] },
        { duration: DUREE, easing: COURBE }
      );

      this.animation.onfinish = () => {
        this.details.open = !ouvrait;
        this.reinitialise();
      };
    } catch (error) {
      this.details.open = !this.details.open;
    }
  }
}

if (!customElements.get('jk-footer-accordion')) {
  customElements.define('jk-footer-accordion', JkFooterAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-galerie"] && !Shopify.designMode) return;
  try {
    
class JkGalerie extends HTMLElement {
  #dialog = null;
  #image = null;
  #caption = null;
  #items = [];
  #current = 0;

  connectedCallback() {
    this.#dialog = this.querySelector('[data-jk-galerie-dialog]');
    this.#image = this.querySelector('[data-jk-galerie-image]');
    this.#caption = this.querySelector('[data-jk-galerie-caption]');
    this.#items = Array.from(this.querySelectorAll('[data-jk-galerie-open]')).map((button) => ({
      full: button.getAttribute('data-full'),
      alt: button.getAttribute('data-alt') || '',
      caption: button.getAttribute('data-caption') || '',
    }));

    this.addEventListener('click', this.#onClick);
    this.#dialog?.addEventListener('keydown', this.#onKeydown);
    this.#dialog?.addEventListener('click', this.#onDialogClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.#dialog?.removeEventListener('keydown', this.#onKeydown);
    this.#dialog?.removeEventListener('click', this.#onDialogClick);
  }

  #onClick = (event) => {
    const opener = event.target.closest('[data-jk-galerie-open]');
    if (opener) {
      this.#open(Number(opener.getAttribute('data-index')) || 0);
      return;
    }
    if (event.target.closest('[data-jk-galerie-close]')) {
      this.#dialog?.close();
      return;
    }
    if (event.target.closest('[data-jk-galerie-prev]')) {
      this.#show(this.#current - 1);
      return;
    }
    if (event.target.closest('[data-jk-galerie-next]')) {
      this.#show(this.#current + 1);
    }
  };

  #open(index) {
    if (!this.#dialog || this.#items.length === 0) return;
    this.#show(index);
    try {
      this.#dialog.showModal();
    } catch (error) {
      this.#dialog.setAttribute('open', '');
    }
  }

  #show(index) {
    const count = this.#items.length;
    if (count === 0 || !this.#image) return;
    this.#current = ((index % count) + count) % count;
    const item = this.#items[this.#current];
    this.#image.src = item.full;
    this.#image.alt = item.alt;
    if (this.#caption) {
      this.#caption.textContent = item.caption;
      this.#caption.hidden = item.caption === '';
    }
  }

  #onKeydown = (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.#show(this.#current - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.#show(this.#current + 1);
    }
  };

  #onDialogClick = (event) => {
    if (event.target.closest('.jk-galerie__full, .jk-galerie__nav, .jk-galerie__close')) return;
    this.#dialog?.close();
  };
}

if (!customElements.get('jk-galerie')) {
  customElements.define('jk-galerie', JkGalerie);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jk-hero"] && !Shopify.designMode) return;
  try {
    
class JkHero extends HTMLElement {
  #slideshow = null;

  connectedCallback() {
    this.#slideshow = this.querySelector('slideshow-component');
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const closeButton = event.target.closest('[data-jk-hero-close]');
    if (closeButton) {
      this.#closeVideo(closeButton);
      return;
    }

    const playButton = event.target.closest('[ref="deferredMediaPlayButton"]');
    if (playButton) {
      this.#playVideo(playButton);
    }
  };

  #playVideo = (button) => {
    try {
      const slide = button.closest('slideshow-slide');
      slide?.setAttribute('data-jk-hero-playing', '');
      this.#slideshow?.pause?.();
    } catch (error) {
      button.closest('slideshow-slide')?.removeAttribute('data-jk-hero-playing');
    }
  };

  #closeVideo = (button) => {
    try {
      const media = button.closest('[data-jk-hero-video]');
      const slide = button.closest('slideshow-slide');
      media?.querySelector('iframe')?.remove();
      media?.removeAttribute('data-media-loaded');
      media?.querySelector('[ref="deferredMediaPlayButton"]')?.classList.remove('deferred-media__playing');
      slide?.removeAttribute('data-jk-hero-playing');
      this.#slideshow?.resume?.();
    } catch (error) {
      button.closest('slideshow-slide')?.removeAttribute('data-jk-hero-playing');
    }
  };
}

if (!customElements.get('jk-hero')) {
  customElements.define('jk-hero', JkHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
